import { render, staticRenderFns } from "./PurchaseOrderVehicleCustomerInsurer.vue?vue&type=template&id=2edf43e2"
import script from "./PurchaseOrderVehicleCustomerInsurer.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderVehicleCustomerInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports